/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpDynamicClientRegistrationRequest
 */
export interface McpDynamicClientRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof McpDynamicClientRegistrationRequest
     */
    clientName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof McpDynamicClientRegistrationRequest
     */
    redirectUris: Array<string>;
    /**
     * 
     * @type {Array<McpDynamicClientRegistrationRequestGrantTypesEnum>}
     * @memberof McpDynamicClientRegistrationRequest
     */
    grantTypes?: Array<McpDynamicClientRegistrationRequestGrantTypesEnum> | null;
    /**
     * 
     * @type {Array<McpDynamicClientRegistrationRequestResponseTypesEnum>}
     * @memberof McpDynamicClientRegistrationRequest
     */
    responseTypes?: Array<McpDynamicClientRegistrationRequestResponseTypesEnum> | null;
    /**
     * 
     * @type {McpDynamicClientRegistrationRequestTokenEndpointAuthMethodEnum}
     * @memberof McpDynamicClientRegistrationRequest
     */
    tokenEndpointAuthMethod?: McpDynamicClientRegistrationRequestTokenEndpointAuthMethodEnum | null;
    /**
     * 
     * @type {McpDynamicClientRegistrationRequestApplicationTypeEnum}
     * @memberof McpDynamicClientRegistrationRequest
     */
    applicationType?: McpDynamicClientRegistrationRequestApplicationTypeEnum | null;
}


/**
 * @export
 */
export const McpDynamicClientRegistrationRequestGrantTypesEnum = {
    AuthorizationCode: 'authorization_code',
    RefreshToken: 'refresh_token'
} as const;
export type McpDynamicClientRegistrationRequestGrantTypesEnum = typeof McpDynamicClientRegistrationRequestGrantTypesEnum[keyof typeof McpDynamicClientRegistrationRequestGrantTypesEnum];

/**
 * @export
 */
export const McpDynamicClientRegistrationRequestResponseTypesEnum = {
    Code: 'code'
} as const;
export type McpDynamicClientRegistrationRequestResponseTypesEnum = typeof McpDynamicClientRegistrationRequestResponseTypesEnum[keyof typeof McpDynamicClientRegistrationRequestResponseTypesEnum];

/**
 * @export
 */
export const McpDynamicClientRegistrationRequestTokenEndpointAuthMethodEnum = {
    None: 'none'
} as const;
export type McpDynamicClientRegistrationRequestTokenEndpointAuthMethodEnum = typeof McpDynamicClientRegistrationRequestTokenEndpointAuthMethodEnum[keyof typeof McpDynamicClientRegistrationRequestTokenEndpointAuthMethodEnum];

/**
 * @export
 */
export const McpDynamicClientRegistrationRequestApplicationTypeEnum = {
    Native: 'native',
    Web: 'web'
} as const;
export type McpDynamicClientRegistrationRequestApplicationTypeEnum = typeof McpDynamicClientRegistrationRequestApplicationTypeEnum[keyof typeof McpDynamicClientRegistrationRequestApplicationTypeEnum];


/**
 * Check if a given object implements the McpDynamicClientRegistrationRequest interface.
 */
export function instanceOfMcpDynamicClientRegistrationRequest(value: object): value is McpDynamicClientRegistrationRequest {
    if ((!('clientName' in (value as Record<string, any>)) && !('client_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['clientName'] === undefined && (value as Record<string, any>)['client_name'] === undefined)) return false;
    if ((!('redirectUris' in (value as Record<string, any>)) && !('redirect_uris' in (value as Record<string, any>))) || ((value as Record<string, any>)['redirectUris'] === undefined && (value as Record<string, any>)['redirect_uris'] === undefined)) return false;
    return true;
}

export function McpDynamicClientRegistrationRequestFromJSON(json: any): McpDynamicClientRegistrationRequest {
    return McpDynamicClientRegistrationRequestFromJSONTyped(json, false);
}

export function McpDynamicClientRegistrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpDynamicClientRegistrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientName': json['client_name'],
        'redirectUris': json['redirect_uris'],
        'grantTypes': json['grant_types'] === undefined ? undefined : json['grant_types'] === null ? null : json['grant_types'],
        'responseTypes': json['response_types'] === undefined ? undefined : json['response_types'] === null ? null : json['response_types'],
        'tokenEndpointAuthMethod': json['token_endpoint_auth_method'] === undefined ? undefined : json['token_endpoint_auth_method'] === null ? null : json['token_endpoint_auth_method'],
        'applicationType': json['application_type'] === undefined ? undefined : json['application_type'] === null ? null : json['application_type'],
    };
}

export function McpDynamicClientRegistrationRequestToJSON(json: any): McpDynamicClientRegistrationRequest {
    return McpDynamicClientRegistrationRequestToJSONTyped(json, false);
}

export function McpDynamicClientRegistrationRequestToJSONTyped(value?: McpDynamicClientRegistrationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_name': value['clientName'],
        'redirect_uris': value['redirectUris'],
        'grant_types': value['grantTypes'],
        'response_types': value['responseTypes'],
        'token_endpoint_auth_method': value['tokenEndpointAuthMethod'],
        'application_type': value['applicationType'],
    };
}

